/** @jsx tsx */
import { tsx } from "@dojo/framework/core/vdom";
import { WidgetBase } from "@dojo/framework/core/WidgetBase";
import { ILineProperties, ISolidFillProperties } from "../interfaces/model/properties/index";

/**
 * Marker render properties interface
 */
export interface IMarkerRenderProps {
    id: string;
    path: string;
    lineProps?: ILineProperties;
    fill?: string;
    markerWidth?: number;
    markerHeight?: number;
    refX?: number;
    refY?: number;
}

/**
 * Marker stateless renderer
 */
export class Marker extends WidgetBase<IMarkerRenderProps> {
	/**
     * Override WidgetBase#render to produce a virtual DOM tree.
     * @returns {HNode} Each time render() executes, it should build the entire virtual DOM tree.
     */
	protected render() {
		const { id, path, lineProps } = this.properties;
		const lineFill = lineProps && lineProps.fill as ISolidFillProperties;
		const lineWidth = lineProps && lineProps.W;
		// path stroke
		const stroke = lineFill && lineFill.color || "black";
		const markerHeight = this.properties.markerHeight || 45720;
		const markerWidth = this.properties.markerHeight || 45720;
		const refX = this.properties.refX || 12;
		const refY = this.properties.refY || 12;
		return (
			<marker
				id={`${id}`}
				key={`marker_${this.properties.key}`}
				markerHeight={`${markerHeight}`}
				markerUnits="strokeWidth"
				markerWidth={`${markerWidth}`}
				orient="auto"
				preserveAspectRatio="none"
				refX={`${refX}`}
				refY={`${refY}`}
				viewBox="0 0 24 24"
			>
				<path
					d={`${path}`}
					fill={`${this.properties.fill || stroke}`}
					stroke={`${stroke}`}
					stroke-dasharray="none"
					stroke-width = {`${lineWidth}`}
				/>
			</marker>
		);
	}
}

export default Marker;
